/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AccountRestrictionResponse = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The AccountRestrictionResponse model module.
   * @module model/AccountRestrictionResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>AccountRestrictionResponse</code>.
   * A response object that includes the restriction ties to an account.
   * @alias module:model/AccountRestrictionResponse
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>AccountRestrictionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountRestrictionResponse} obj Optional instance to populate.
   * @return {module:model/AccountRestrictionResponse} The populated <code>AccountRestrictionResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('dataDefinition')) {
        obj['dataDefinition'] = ApiClient.convertToType(data['dataDefinition'], 'String');
      }
    }
    return obj;
  }

  /**
   * The ID of the restriction.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * The type of the restriction, such as \"HIT\", \"TIMEOFDAY\", \"ORIGIN\".
   * @member {String} type
   */
  exports.prototype['type'] = undefined;
  /**
   * The name of the restriction.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * The definition of the restriction.
   * @member {String} dataDefinition
   */
  exports.prototype['dataDefinition'] = undefined;



  return exports;
}));



